export enum DesignOptions {
  tabs = "tabs",
  list = "list",
  column = "column",
  image_text_list = "image-text-list",
  checkbox_list = "checkbox-list",
  round_checkbox_list = "radio-list",
  text_list = "text-list",
  range = "range",
  range_list = "range-list",
  range_slider = "range-slider",
  dropdown = "dropdown",
  text_list_with_values = "text-list-with-values",
  checkbox_list_text_list = "checkbox-list-text-list",
  image_text_list_range = "image-text-list-range",
  select_list = "select-list",
  collection_dropdown = "collection-dropdown",
  collection_subcategories = "collection-subcategories",
  label_only = "label-only",
  web_view = "web-view",
  stock_search = "stock-search",
  text_list_dynamic_width = "text-list-dw",
}

export enum SelectionType {
  single = "single",
  multiple = "multiple",
  range = "range",
}
